export const ANSWERS_DATA = {
  keyword: [
    {
      code01: {
        answerData: "code01",
        DateVal: "code01",
        titImgClass: "quizTit1",
        hintWhetherIs: true,
        hintContent: "첫 글자는 T입니다.",
      },
      time02: {
        answerData: "time02",
        DateVal: "time02",
        titImgClass: "quizTit2",
        hintWhetherIs: true,
        hintContent: `
          가장 적은 야근 기록은 2회입니다.<br/>
          <br/>
          알파벳	역순 배치<br/>
          A	26<br/>
          B	25<br/>
          C	24<br/>
          D	23<br/>
          ...<br/>
          W	4<br/>
          X	3<br/>
          Y	2<br/>
          Z	1
        `,
      },
      time03: {
        answerData: "time03",
        DateVal: "time03",
        titImgClass: "quizTit3",
        hintWhetherIs: true,
        hintContent: `
          "남쪽 복도(H) → <br/>
          북쪽 복도(B) → <br/>
          서쪽 1번째 방"
        `,
      },
      trace4: {
        answerData: "trace4",
        DateVal: "trace4",
        titImgClass: "quizTit4",
        hintWhetherIs: true,
        hintContent: `
          음계를 숫자로 바꾸기 → <br/>
          흩어진 조각과 연결하기 → <br/>
          순서 확인하기
        `,
      },
      mind05: {
        answerData: "mind05",
        DateVal: "mind05",
        titImgClass: "quizTit5",
        hintWhetherIs: true,
        hintContent: `
          갑자기 밝아진 시점(10월 25일)과<br/>
          상담 취소 시점이 일치함
        `,
      },
      file06: {
        answerData: "file06",
        DateVal: "file06",
        titImgClass: "quizTit6",
        hintWhetherIs: true,
        hintContent: `
          시작시간 - 종료시간 = ?
        `,
      },
      lang07: {
        answerData: "lang07",
        DateVal: "lang07",
        titImgClass: "quizTit7",
        hintWhetherIs: true,
        hintContent: `
          마방진은 어디서든 숫자가 일치하지.<br/>
          <br/>
          마방진(魔方陣, 영어: magic square) 또는 방진(方陣)은 n2개의 수를<br/>
          가로, 세로,  두 대각선 방향의 수를<br/>
          더하면 모두 같은 값이 나오도록<br/>
          n × n 행렬에 배열한 것이다.
        `,
      },
      alarm8: {
        answerData: "alarm8",
        DateVal: "alarm8",
        titImgClass: "quizTit8",
        hintWhetherIs: true,
        hintContent: `
          알람을 해제할 수 있는 권한은<br/>
          차장에게 있어.
        `,
      },
      cross9: {
        answerData: "cross9",
        DateVal: "cross9",
        titImgClass: "quizTit9",
        hintWhetherIs: true,
        hintContent: `
          모든 알리바이 입증이<br/>
          무죄를 말하는 것은 아니다.
        `,
      },
      final0: {
        DateVal: "final0",
        titImgClass: "quizTit10",
      },
      ih01: {
        type: "place",
        keyword: "ih01",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_ih01.png",
          },
        ],
      },
      ih02: {
        type: "place",
        keyword: "ih02",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_ih02.png",
          },
        ],
      },
      ih03: {
        type: "place",
        keyword: "ih03",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_ih03.png",
          },
        ],
      },
      ih04: {
        type: "place",
        keyword: "ih04",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_ih04.png",
          },
        ],
      },
      ih05: {
        type: "place",
        keyword: "ih05",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_ih05.png",
          },
        ],
      },
      sv01: {
        type: "place",
        keyword: "sv01",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_sv01.png",
          },
        ],
      },
      sv02: {
        type: "place",
        keyword: "sv02",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_sv02.png",
          },
        ],
      },
      sv03: {
        type: "place",
        keyword: "sv03",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_sv03.png",
          },
        ],
      },
      sv04: {
        type: "place",
        keyword: "sv04",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_sv04.png",
          },
        ],
      },
      sv05: {
        type: "place",
        keyword: "sv05",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_sv05.png",
          },
        ],
      },
      lo01: {
        type: "place",
        keyword: "lo01",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_lo01.png",
          },
        ],
      },
      lo02: {
        type: "place",
        keyword: "lo02",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_lo02.png",
          },
        ],
      },
      lo03: {
        type: "place",
        keyword: "lo03",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_lo03.png",
          },
        ],
      },
      lo04: {
        type: "place",
        keyword: "lo04",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_lo04.png",
          },
        ],
      },
      lo05: {
        type: "place",
        keyword: "lo05",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_lo05.png",
          },
        ],
      },
      ga01: {
        type: "place",
        keyword: "ga01",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_ga01.png",
          },
        ],
      },
      ga02: {
        type: "place",
        keyword: "ga02",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_ga02.png",
          },
        ],
      },
      ga03: {
        type: "place",
        keyword: "ga03",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_ga03.png",
          },
        ],
      },
      ga04: {
        type: "place",
        keyword: "ga04",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_ga04.png",
          },
        ],
      },
      ga05: {
        type: "place",
        keyword: "ga05",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_ga05.png",
          },
        ],
      },
      gr01: {
        type: "place",
        keyword: "gr01",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_gr01.png",
          },
        ],
      },
      gr02: {
        type: "place",
        keyword: "gr02",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_gr02.png",
          },
        ],
      },
      gr03: {
        type: "place",
        keyword: "gr03",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_gr03.png",
          },
        ],
      },
      gr04: {
        type: "place",
        keyword: "gr04",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_gr04.png",
          },
        ],
      },
      gr05: {
        type: "place",
        keyword: "gr05",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_gr05.png",
          },
        ],
      },
      le01: {
        type: "place",
        keyword: "le01",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_le01.png",
          },
        ],
      },
      le02: {
        type: "place",
        keyword: "le02",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_le02.png",
          },
        ],
      },
      le03: {
        type: "place",
        keyword: "le03",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_le03.png",
          },
        ],
      },
      le04: {
        type: "place",
        keyword: "le04",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_le04.png",
          },
        ],
      },
      le05: {
        type: "place",
        keyword: "le05",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_le05.png",
          },
        ],
      },
      op01: {
        type: "place",
        keyword: "op01",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_op01.png",
          },
        ],
      },
      op02: {
        type: "place",
        keyword: "op02",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_op02.png",
          },
        ],
      },
      op03: {
        type: "place",
        keyword: "op03",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_op03.png",
          },
        ],
      },
      op04: {
        type: "place",
        keyword: "op04",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_op04.png",
          },
        ],
      },
      op05: {
        type: "place",
        keyword: "op05",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_op05.png",
          },
        ],
      },
      wi01: {
        type: "place",
        keyword: "wi01",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_wi01.png",
          },
        ],
      },
      wi02: {
        type: "place",
        keyword: "wi02",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_wi02.png",
          },
        ],
      },
      wi03: {
        type: "place",
        keyword: "wi03",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_wi03.png",
          },
        ],
      },
      wi04: {
        type: "place",
        keyword: "wi04",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_wi04.png",
          },
        ],
      },
      wi05: {
        type: "place",
        keyword: "wi05",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_wi05.png",
          },
        ],
      },
      ha01: {
        type: "place",
        keyword: "ha01",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_ha01.png",
          },
        ],
      },
      ha02: {
        type: "place",
        keyword: "ha02",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_ha02.png",
          },
        ],
      },
      ha03: {
        type: "place",
        keyword: "ha03",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_ha03.png",
          },
        ],
      },
      ha04: {
        type: "place",
        keyword: "ha04",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_ha04.png",
          },
        ],
      },
      ha05: {
        type: "place",
        keyword: "ha05",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_ha05.png",
          },
        ],
      },
      el01: {
        type: "place",
        keyword: "el01",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_el01.png",
          },
        ],
      },
      el02: {
        type: "place",
        keyword: "el02",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_el02.png",
          },
        ],
      },
      el03: {
        type: "place",
        keyword: "el03",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_el03.png",
          },
        ],
      },
      el04: {
        type: "place",
        keyword: "el04",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_el04.png",
          },
        ],
      },
      el05: {
        type: "place",
        keyword: "el05",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_el05.png",
          },
        ],
      },
    },
  ],
};
